document.addEventListener('turbolinks:load', () => {
  const searchInput = document.getElementById('unit-address-search-input');
  const resultsContainer = document.getElementById('unit-address-search-results');
  const loadingIndicator = document.getElementById('unit-address-search-loading');
  const noResultsMessage = document.getElementById('unit-address-no-results');

  if (!searchInput || !resultsContainer) return;

  let timeout = null;

  searchInput.addEventListener('input', () => {
    const query = searchInput.value.trim();

    clearTimeout(timeout);

    // Hide messages initially
    if (loadingIndicator) loadingIndicator.classList.add('hidden');
    if (noResultsMessage) noResultsMessage.classList.add('hidden');

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }

    // Show loading indicator
    if (loadingIndicator) loadingIndicator.classList.remove('hidden');

    timeout = setTimeout(() => {
      fetch(`/v2/unit_address_searches/search?query=${encodeURIComponent(query)}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        if (loadingIndicator) loadingIndicator.classList.add('hidden');
        displaySearchResults(data, resultsContainer, noResultsMessage);
      })
      .catch(error => {
        if (loadingIndicator) loadingIndicator.classList.add('hidden');
        resultsContainer.innerHTML = '<div class="p-4 bg-red-100 text-red-700 rounded">Error fetching results. Please try again.</div>';
      });
    }, 300);
  });

  function displaySearchResults(data, container, noResultsMsg) {
    container.innerHTML = '';

    if (data.length === 0) {
      if (noResultsMsg) noResultsMsg.classList.remove('hidden');
      return;
    }

    if (noResultsMsg) noResultsMsg.classList.add('hidden');

    data.forEach(unit => {
      const unitLink = document.createElement('a');
      unitLink.href = `/orders/${unit.order_id}/unit_singles/${unit.id}`;
      unitLink.classList.add(
        'block',
        'p-4',
        'bg-white',
        'shadow',
        'rounded-lg',
        'hover:bg-gray-50',
        'transition-colors',
        'border',
        'border-gray-200'
      );

      unitLink.innerHTML = `
        <div class="flex flex-col md:flex-row md:items-center md:justify-between">
          <div class="flex-1">
            <div class="font-semibold text-blue-600 hover:text-blue-800">${escapeHtml(unit.add_str)}</div>
            <div class="text-sm text-gray-600 mt-1">
              <span class="font-medium">Unit ID:</span> ${escapeHtml(unit.identifier || 'N/A')}
              ${unit.name ? ` | <span class="font-medium">Name:</span> ${escapeHtml(unit.name)}` : ''}
            </div>
          </div>
          <div class="mt-2 md:mt-0 md:ml-4 text-sm text-gray-500">
            <span class="font-medium">Order:</span> ${escapeHtml(unit.order_hoa_name || 'N/A')}
          </div>
        </div>
      `;

      container.appendChild(unitLink);
    });
  }

  function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
});
